"use strict";

exports.__esModule = true;
exports.ON_DIALOG_OPEN_CHANGED = void 0;
const namespace = 'DIALOGS';
const ON_DIALOG_OPEN_CHANGED = namespace + "@ON_DIALOG_OPEN_CHANGED";
exports.ON_DIALOG_OPEN_CHANGED = ON_DIALOG_OPEN_CHANGED;